import {BaseIdModel} from "common-shared";
import {Type} from "class-transformer";

export class ItemLogModel extends BaseIdModel {
  constructor(init?: Partial<ItemLogModel>) {
    super();
    Object.assign(this, init);
  }
  ItemId: string;
  CreatedBy: string;
  @Type(() => Date)
  CreatedDate: Date;

  @Type(() => Date)
  Start?: Date;
  @Type(() => Date)
  End?: Date;
  StatusClv: string;
  Description: string;
  AssignedTo: string;
  Content: string;
  Context: string;
}
